import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgScale = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M21.375 5.75C21.375 5.58424 21.3092 5.42527 21.1919 5.30806C21.0747 5.19085 20.9158 5.125 20.75 5.125H18.875V3.25C18.875 3.08424 18.8092 2.92527 18.6919 2.80806C18.5747 2.69085 18.4158 2.625 18.25 2.625H17C16.8342 2.625 16.6753 2.69085 16.5581 2.80806C16.4408 2.92527 16.375 3.08424 16.375 3.25V5.125H14.5C14.3342 5.125 14.1753 5.19085 14.0581 5.30806C13.9408 5.42527 13.875 5.58424 13.875 5.75V7C13.875 7.16576 13.9408 7.32473 14.0581 7.44194C14.1753 7.55915 14.3342 7.625 14.5 7.625H16.375V9.5C16.375 9.66576 16.4408 9.82473 16.5581 9.94194C16.6753 10.0592 16.8342 10.125 17 10.125H18.25C18.4158 10.125 18.5747 10.0592 18.6919 9.94194C18.8092 9.82473 18.875 9.66576 18.875 9.5V7.625H20.75C20.9158 7.625 21.0747 7.55915 21.1919 7.44194C21.3092 7.32473 21.375 7.16576 21.375 7V5.75Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 20.125L21.375 14.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 17.3125L14.8608 21.375H8.61084"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 13.25C3.25 13.6208 3.35997 13.9834 3.566 14.2917C3.77202 14.6 4.06486 14.8404 4.40747 14.9823C4.75008 15.1242 5.12708 15.1613 5.4908 15.089C5.85451 15.0166 6.1886 14.838 6.45083 14.5758C6.71305 14.3136 6.89163 13.9795 6.96397 13.6158C7.03632 13.2521 6.99919 12.8751 6.85728 12.5325C6.71536 12.1899 6.47504 11.897 6.16669 11.691C5.85835 11.485 5.49584 11.375 5.125 11.375C4.75416 11.375 4.39165 11.265 4.08331 11.059C3.77496 10.853 3.53464 10.5601 3.39273 10.2175C3.25081 9.87492 3.21368 9.49792 3.28603 9.13421C3.35838 8.77049 3.53695 8.4364 3.79918 8.17418C4.0614 7.91195 4.39549 7.73338 4.75921 7.66103C5.12292 7.58868 5.49992 7.62581 5.84253 7.76773C6.18514 7.90964 6.47798 8.14996 6.68401 8.45831C6.89003 8.76665 7 9.12916 7 9.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.125 6.375V7.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.125 15.125V16.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgScale.displayName = 'SvgScale';
export default SvgScale;
